export class ReturnToTop {
	public constructor(elTrigger: HTMLElement | null, elObserve: HTMLElement | null) {
		if (!elTrigger || !elObserve) {
			return;
		}

		new IntersectionObserver(entries => {
			const isIntersecting = entries[0]?.isIntersecting ?? false;
			elTrigger.setAttribute("aria-hidden", (isIntersecting).toString());
		}).observe(elObserve);
	}
}
